/*!
 * jQuery section filter function
 * Filters elements by Shopify section ID.
 * If the section ID is undefined, all sections are selected
 */ const isObject = (term)=>{
    return term !== null && typeof term === 'object';
};
const checkShopifyEvent = function(evt) {
    return isObject(evt) && 'originalEvent' in evt && isObject(evt.originalEvent) && 'detail' in evt.originalEvent && isObject(evt.originalEvent.detail) && 'sectionId' in evt.originalEvent.detail && typeof evt.originalEvent.detail.sectionId === 'string' && evt.originalEvent.detail.sectionId.length > 0;
};
export const filterSections = function filterSections(shopifyEvent) {
    const sectionId = checkShopifyEvent(shopifyEvent) ? shopifyEvent.originalEvent.detail.sectionId : '';
    return function(_, element) {
        return !sectionId ? true : element.getAttribute('id') === 'shopify-section-' + sectionId ? true : element.getAttribute('data-section-id') === sectionId;
    };
};
